"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transition = void 0;
exports.transition = {
    fast: 'all 0.2s ease-in',
    slow: 'all 0.3s ease-in',
};
//# sourceMappingURL=transition.js.map